import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from '../app-routing.module';
import { MaterialModule } from '../material/material.module';
import { PipesModule } from '../utilities/pipes/pipes.module';

import { ProjectService } from './shared/services/project.service';

import { ProjectsComponent } from './projects.component';
import { ProjectsListComponent } from './projects-list/projects-list.component';
import { ProjectDetailComponent } from './project-detail/project-detail.component';

@NgModule({
  imports: [
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    MaterialModule,
    PipesModule
  ],
  declarations: [
    ProjectsComponent,
    ProjectsListComponent, 
    ProjectDetailComponent],
  providers: [ProjectService],
  exports: [
    ProjectsComponent,
    ProjectDetailComponent,
    ProjectsListComponent
  ]
})
export class ProjectsModule { }



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/projects/projects.module.ts